import { useState, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { notifyInfo } from "../../Response/ResposeHandler";

import {
  GetSite,
  GetShopId,
  CreateEmptySite
} from "./Requests";

import "./MiniSite.css";
import General from "./General";
import Theme from "./Theme";
import BusinessInfo from "./BussinessInfo";
import SiteSections from "./SiteSections";
import Socials from "./Socials";
import { useTranslation } from "react-i18next";

const MiniSite = () => {
  const { t } = useTranslation("miniSite");

  const [site, setSite] = useState("setup");
  const [shopId, setShopId] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [tab, setTab] = useState("General");

  useEffect(() => {
    GetSiteWrapper();
  }, []);

  function GetSiteWrapper() {
    GetSite()
      .then((res) => {
        setSite(res.data);
      })
      .catch(() => {
        // no-op
      })
      .finally(() => {
        GetShopDetailsWrapper();
      });
  }

  function GetShopDetailsWrapper() {
    GetShopId()
      .then((res) => {
        setShopId(res.data);
      })
      .catch(() => {
        // no-op
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  function CreateEmptySiteWrapper() {
    CreateEmptySite()
      .then(() => {
        setSite("setup");
      })
      .catch(() => {
        // no-op
      })
      .finally(() => {
        GetSiteWrapper();
      });
  }

  const renderTabs = () => {
    switch (tab.toLowerCase()) {
      case "general":
        return (
          <div>
            <General shopId={shopId} site={site} />
          </div>
        );
      case "details":
        return (
          <>
            <BusinessInfo site={site} getSite={GetSiteWrapper} />
          </>
        );
      case "sections":
        return (
          <div>
            <SiteSections site={site} getSite={GetSiteWrapper} />
          </div>
        );
      case "theme":
        return (
          <>
            <Theme shopId={shopId} site={site} getSite={GetSiteWrapper} />
          </>
        );
      case "socials":
        return (
          <>
            <Socials site={site} getSite={GetSiteWrapper} />
          </>
        );
      default:
        return null;
    }
  };

  const bookingUrl =
    `${process.env.REACT_APP_CLIENT_BASE_URL}make-a-booking?id=${shopId}`;

  return (
    <div>
      {isLoading ? (
        <div className="custom-loader-wrapper" role="status" aria-live="polite" aria-label={t("status.loadingAria")}>
          <div className="custom-loader"></div>
        </div>
      ) : null}

      <div>
        {!isLoading && site === "" ? (
          <div className="mini-card">
            <section className="mini-section">
              <h2 className="mini-h2">{t("titles.directBookingLink")}</h2>
              <p className="mini-text">
                {t("descriptions.directBookingLink")}
              </p>

              <div className="mini-linkRow">
                <a
                  target="_blank"
                  rel="noreferrer"
                  className="mini-link"
                  href={`make-a-booking?id=${shopId}`}
                  title={t("actions.openBookingPortal")}
                  aria-label={t("actions.openBookingPortal")}
                >
                  {bookingUrl}
                </a>

                <button
                  type="button"
                  className="mini-copyBtn"
                  aria-label={t("actions.copyBookingLink")}
                  onClick={async () => {
                    notifyInfo(t("toasts.copiedBookingLink"));
                    try {
                      await navigator.clipboard.writeText(bookingUrl);
                    } catch {}
                  }}
                  title={t("actions.copyLink")}
                >
                  <svg
                    viewBox="0 0 24 24"
                    className="mini-copyIcon"
                    aria-hidden="true"
                  >
                    <path d="M16 1H6a2 2 0 0 0-2 2v11h2V3h10V1zm3 4H10a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zm0 16H10V7h9v14z" />
                  </svg>
                </button>
              </div>
            </section>

            <hr className="mini-divider" />
            <ToastContainer />

            <section className="mini-section">
              <h2 className="mini-h2">{t("titles.setupMiniSite")}</h2>
              <p className="mini-text">
                {t("descriptions.setupMiniSite")}
              </p>

              <div className="mini-actions mini-actions--center">
                <button
                  className="mini-btn mini-btn--primary"
                  onClick={() => {
                    CreateEmptySiteWrapper();
                  }}
                >
                  {t("actions.setupMiniSite")}
                </button>
              </div>
            </section>
          </div>
        ) : !isLoading ? (
          <div className="container">
            <div className="sub-nav" style={{ marginTop: 0 }}>
              {["General", "Theme", "Details", "Sections", "Socials"].map(
                (tabOption) => (
                  <a
                    key={tabOption}
                    href="#"
                    className={`sub-tab ${tab === tabOption ? "active" : ""}`}
                    onClick={() => setTab(tabOption)}
                    aria-current={tab === tabOption ? "page" : undefined}
                  >
                    {t(`tabs.${tabOption.toLowerCase()}`)}
                  </a>
                )
              )}
            </div>
            {renderTabs()}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default MiniSite;
